// extracted by mini-css-extract-plugin
export default {"unauthorized":"J2iCfdkCP7J38VaB8sHk"};